/**
 * Title Input Component.
 * Separate input field for document title above the editor.
 */

import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';
import type { TitleInputProps } from '../types/editor';

export const TitleInput = React.forwardRef<HTMLInputElement, TitleInputProps>(
  ({ value, onChange, disabled, placeholder }, ref) => {
    const { t } = useTranslation();
    const defaultPlaceholder = t('common:editor.untitledDocument');
    return (
      <input
        ref={ref}
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        placeholder={placeholder ?? defaultPlaceholder}
        className={cn(
          'w-full text-2xl font-bold bg-transparent border-none outline-none',
          'placeholder:text-muted-foreground/50',
          'focus:outline-none focus:ring-0',
          'disabled:cursor-not-allowed disabled:opacity-50',
          'px-4 py-3',
        )}
        aria-label="Document title"
      />
    );
  },
);

TitleInput.displayName = 'TitleInput';
